import { render } from "./search-filter-child-simple.vue?vue&type=template&id=74160d20&scoped=true"
import script from "./search-filter-child-simple.vue?vue&type=script&lang=js"
export * from "./search-filter-child-simple.vue?vue&type=script&lang=js"

import "./search-filter-child-simple.vue?vue&type=style&index=0&id=74160d20&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74160d20"]])

export default __exports__